export const missingAirlineCode = [
  "V2",
  "IP",
  "6P",
  "I3",
  "KH",
  "K4",
  "J6",
  "/K",
  "5K",
  "EB",
  "T8",
  "1B",
  "EB",
  "1J",
  "2O",
  "4A",
  "5K",
  "1M",
  "C1",
  "D1",
  "1E",
  "1F",
  "1K"
]
